import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const ENCIceBlue = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path
      d="M12.335625 0l3.7125 7.951875L24 11.664375V0H12.335625zM0 0v11.664375l7.951875-3.7125L11.664375 0H0zm16.048125 16.048125L12.335625 24H24V12.335625l-7.951875 3.7125zM0 24h11.664375l-3.7125-7.951875L0 12.335625V24z"
      fill="#8DC7E9"
      fillRule="evenodd"
    />
  </SvgIcon>
);

export default ENCIceBlue;
